module.exports = __webpack_public_path__ + "img/banheiro-xpto.509c6799.jpg";